import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

// --- IMPORTS DE PDF (Manteniendo los tuyos) ---
import pdfAutomatizacion from "../../static/media/tienda/CATALOGO-ELECTRICA-GRM.pdf";
import pdfPiezas from "../../static/media/tienda/Catalogo-VETO-2022.pdf";
import pdfIluminacion from "../../static/media/tienda/CATALOGO-2022-LEDVANCE.pdf";

// --- IMPORTS DE IMÁGENES SEGÚN CAPTURA ---
// Ajusta la ruta "../marcas/" a la carpeta real donde guardaste las imágenes
import FamiliaImg from "../../static/media/tienda/familia.webp";
import LedvanceImg from "../../static/media/tienda/Ledvance.webp";
import VetoImg from "../../static/media/tienda/veto.webp";

// Carrusel de marcas
import Camsco from "../../static/media/tienda/camsco.webp";
import Cobres from "../../static/media/tienda/cobres.webp";
import Comap from "../../static/media/tienda/comap.webp";
import Cutler from "../../static/media/tienda/cutler.webp";
import Ducati from "../../static/media/tienda/ducati.webp";
import Ebasee from "../../static/media/tienda/ebasee.webp";
import GE from "../../static/media/tienda/General_Electric.webp";
import Hibox from "../../static/media/tienda/HIBOX.webp";
import Icm from "../../static/media/tienda/ICM.webp";
import Jsl from "../../static/media/tienda/jsl.webp";
import Legrand from "../../static/media/tienda/legrand.webp";
import Megatone from "../../static/media/tienda/megatone.webp";
import Osemco from "../../static/media/tienda/osemco.webp";
import QW from "../../static/media/tienda/Q&W.webp";
import Saci from "../../static/media/tienda/saci.webp";
import Sbox from "../../static/media/tienda/Sbox.webp";
import Tenmars from "../../static/media/tienda/tenmars.webp";

const C = {
  dark: "#0C1F2F",
  navy: "#0057A8",
  gold: "#FFCD00",
  goldDark: "#E6B800",
  white: "#ffffff",
  gray: "#F5F7FA",
};

const MARCAS_CARRUSEL = [
  Camsco,
  Cobres,
  Comap,
  Cutler,
  Ducati,
  Ebasee,
  GE,
  Hibox,
  Icm,
  Jsl,
  Legrand,
  Megatone,
  Osemco,
  QW,
  Saci,
  Sbox,
  Tenmars,
];

export default function Catalogos() {
  return (
    <Box
      id="catalogos"
      sx={{
        background: C.white,
        minHeight: { xs: "auto", lg: "100vh" }, // Se adapta a pantalla completa en desktop
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        py: { xs: 8, lg: 0 },
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          maxWidth: "1280px",
          mx: "auto",
          width: "100%",
          px: { xs: 3, sm: 5, md: 6 },
          zIndex: 1,
          display: "flex",
          flexDirection: { xs: "column", lg: "row" },
          alignItems: "center",
          gap: { xs: 6, lg: 8 },
        }}
      >
        {/* === COLUMNA IZQUIERDA: IMAGEN FAMILIA === */}
        <Box
          sx={{
            width: { xs: "100%", lg: "45%" },
            display: "flex",
            justifyContent: "center",
            position: "relative",
          }}
        >
          {/* Fondo decorativo sutil para que la imagen no flote en la nada */}
          <Box
            component={motion.div}
            initial={{ opacity: 0, scale: 0.8 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            sx={{
              position: "absolute",
              width: "80%",
              height: "80%",
              background: C.gray,
              borderRadius: "50%",
              zIndex: 0,
              top: "10%",
            }}
          />
          {/* Imagen principal con animación de entrada y flotación */}
          <Box
            component={motion.img}
            src={FamiliaImg}
            alt="Familia revisando catálogos"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            animate={{ y: [-5, 5, -5] }} // Efecto de flotación continua
            sx={{
              width: "100%",
              maxWidth: "500px",
              height: "auto",
              objectFit: "contain",
              zIndex: 1,
              position: "relative",
              filter: "drop-shadow(0px 20px 30px rgba(0,0,0,0.1))",
            }}
          />
        </Box>

        {/* === COLUMNA DERECHA: TEXTOS Y BOTONES === */}
        <Box
          sx={{
            width: { xs: "100%", lg: "55%" },
            display: "flex",
            flexDirection: "column",
            alignItems: { xs: "center", lg: "flex-start" },
            textAlign: { xs: "center", lg: "left" },
          }}
        >
          <Box
            component={motion.div}
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <Typography
              variant="h2"
              sx={{
                color: C.dark,
                fontWeight: 750,
                fontSize: { xs: 28, sm: 34, md: 40 },
                letterSpacing: "-.02em",
                lineHeight: 1.1,
                mb: 2,
              }}
            >
              Revisa nuestros{" "}
              <br sx={{ display: { xs: "none", lg: "block" } }} />
              <Box component="span" sx={{ color: C.navy }}>
                catálogos
              </Box>
            </Typography>
            <Typography
              sx={{
                color: "#5c6c7a",
                fontSize: { xs: 14, md: 16 },
                lineHeight: 1.6,
                maxWidth: "450px",
                mb: 5,
              }}
            >
              Descubre nuestra amplia gama de productos. Selecciona la marca de
              tu interés para descargar el catálogo completo y conocer nuestras
              soluciones.
            </Typography>
          </Box>

          <Box
            component={motion.div}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              alignItems: { xs: "center", sm: "stretch" }, // <-- Agregar
              justifyContent: { xs: "center", lg: "flex-start" },
              gap: 3,
              mb: 4,
              width: "100%",
            }}
          >
            {/* Botón Iluminación - Ledvance */}
            <Box
              component="a"
              href={pdfIluminacion}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                background: C.white,
                border: "1px solid #EAEAEA",
                borderRadius: "16px",
                p: 3,
                width: { xs: "100%", sm: "220px" },
                textDecoration: "none",
                boxShadow: "0 8px 24px rgba(12, 31, 47, 0.05)",
                transition: "all 0.3s ease",
                "&:hover": {
                  transform: "translateY(-5px)",
                  boxShadow: "0 15px 35px rgba(12, 31, 47, 0.1)",
                  borderColor: "rgba(12, 31, 47, 0.1)",
                },
              }}
            >
              <Box
                component="img"
                src={LedvanceImg}
                alt="Catálogo Ledvance Iluminación"
                sx={{
                  height: "45px",
                  width: "auto",
                  objectFit: "contain",
                  mb: 2,
                }}
              />
              <Typography
                sx={{ color: C.dark, fontWeight: 500, fontSize: "0.9rem" }}
              >
                Catálogo Iluminación
              </Typography>
            </Box>

            {/* Botón Piezas Eléctricas - Veto */}
            <Box
              component="a"
              href={pdfPiezas}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                background: C.white,
                border: "1px solid #EAEAEA",
                borderRadius: "16px",
                p: 3,
                width: { xs: "100%", sm: "220px" },
                textDecoration: "none",
                boxShadow: "0 8px 24px rgba(12, 31, 47, 0.05)",
                transition: "all 0.3s ease",
                "&:hover": {
                  transform: "translateY(-5px)",
                  boxShadow: "0 15px 35px rgba(12, 31, 47, 0.1)",
                  borderColor: "rgba(12, 31, 47, 0.1)",
                },
              }}
            >
              <Box
                component="img"
                src={VetoImg}
                alt="Catálogo Veto Piezas"
                sx={{
                  height: "45px",
                  width: "auto",
                  objectFit: "contain",
                  mb: 2,
                }}
              />
              <Typography
                sx={{ color: C.dark, fontWeight: 500, fontSize: "0.9rem" }}
              >
                Piezas Eléctricas
              </Typography>
            </Box>
          </Box>

          {/* BOTÓN OTRAS MARCAS (Centrado respecto a su contenedor) */}
          <Box
            component={motion.div}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.3 }}
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: { xs: "center", lg: "flex-end" },
              mb: 5,
              pr: { lg: "10%" }, // Ajusta este valor según necesites
            }}
          >
            <Box
              component="a"
              href={pdfAutomatizacion} // Vinculado al catálogo general
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                background: C.gold,
                color: C.dark,
                px: 4,
                py: 1.5,
                borderRadius: "50px",
                textDecoration: "none",
                fontWeight: 700,
                fontSize: "14px",
                boxShadow: "0 8px 20px rgba(255, 205, 0, 0.25)",
                transition: "all 0.2s ease",
                mr: { lg: "45%" }, // Añade esta línea
                "&:hover": {
                  background: C.goldDark,
                  transform: "translateY(-2px)",
                  boxShadow: "0 12px 25px rgba(255, 205, 0, 0.35)",
                },
              }}
            >
              Ver Otras Marcas
            </Box>
          </Box>

          {/* CARRUSEL DE MARCAS INFERIOR */}
          <Box
            component={motion.div}
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.4 }}
            sx={{
              width: "100%",
              maxWidth: { xs: "100%", lg: "550px" }, // Limita el ancho del carrusel a la columna
              position: "relative",
            }}
          >
            <Swiper
              modules={[Autoplay]}
              loop={true}
              spaceBetween={20}
              autoplay={{
                delay: 2000,
                disableOnInteraction: false,
              }}
              breakpoints={{
                0: { slidesPerView: 3 },
                600: { slidesPerView: 4 },
                900: { slidesPerView: 5 },
              }}
              style={{ padding: "10px 0" }}
            >
              {MARCAS_CARRUSEL.map((src, i) => (
                <SwiperSlide key={i}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "50px",
                      background: C.white,
                      borderRadius: "8px",
                      border: "1px solid #F0F0F0",
                      p: 1,
                      transition: "transform 0.2s",
                      "&:hover": { transform: "scale(1.05)" },
                    }}
                  >
                    <Box
                      component="img"
                      src={src}
                      alt={`Marca aliada ${i}`}
                      sx={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                        filter: "grayscale(0%)",
                        opacity: 0.6,
                        transition: "all 0.3s ease",
                        "&:hover": { filter: "grayscale(50%)", opacity: 1 },
                      }}
                    />
                  </Box>
                </SwiperSlide>
              ))}
            </Swiper>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
